import useWorkspaceAccessibleValidation from '../../validations/WorkspaceAccessible';
import { BaseValidationTypes } from './types';

const useBaseValidations = (): {
  [key in BaseValidationTypes]: (event: any) => boolean;
} => {
  const onWorkspaceAccessible = useWorkspaceAccessibleValidation();

  return {
    'workspace-accessible': onWorkspaceAccessible,
  };
};

export default useBaseValidations;
